import React, { useEffect } from 'react';
import I18n from 'i18n-js';
import CheckoutLoadingIndicator from './checkout_loading_indicator';
import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { withReverbAppInput } from './checkoutActionHooks';
import {
  core_apimessages_CheckoutAction_Type as CheckoutActionType,
  Core_Checkout_FetchDigitalWalletPaymentCheckoutQuery,
  core_apimessages_Error as Error,
} from '@reverbdotcom/commons/src/gql/graphql';
import Location from '../lib/wrapped_location';

type Checkout = Core_Checkout_FetchDigitalWalletPaymentCheckoutQuery['checkout'];
type CheckoutItemPageReturnError = 'PAYMENT_FAILURE' | 'CHECKOUT_FAILURE' | 'STANDARD_USER_ATTEMPTED_GUEST_CHECKOUT_FAILURE';

export function BuyItNowPaymentProcessing({
  checkoutId,
  onError,
}: {
  checkoutId: string;
  onError: (errors: Error[]) => void;
}) {
  const url = useURL();

  const { data, loading, stopPolling } = useQuery(CHECKOUT_QUERY, {
    variables: {
      id: checkoutId,
      ...withReverbAppInput(url),
    },
    pollInterval: 500,
    errorPolicy: 'ignore',
    fetchPolicy: 'network-only',
  });
  const { checkout } = data ?? {};

  useEffect(() => {
    if (!loading && checkout) {
      if (checkout.action.type === CheckoutActionType.CHECKOUT_SUCCESS) {
        stopPolling();
        Location.assign(checkout.action.redirectUrl);
      }

      const errorType = findCheckoutErrorType(checkout);

      if (errorType) {
        stopPolling();
        onError([{ message: checkout.paymentErrorMessage }]);
      }
    }
  }, [checkout, loading, onError, stopPolling]);

  return (
    <CheckoutLoadingIndicator
      title={I18n.t('discovery.checkout.redirectReturnLayout.paymentProcessing')}
    />
  );
}

function findCheckoutErrorType(checkout: Checkout): CheckoutItemPageReturnError {
  if (checkout.action.type === CheckoutActionType.PAYMENT_FAILURE || checkout.action.type === CheckoutActionType.CHECKOUT_FAILURE) {
    return checkout.action.type;
  }
  return undefined;
}

export const CHECKOUT_QUERY = gql(`
  query Core_Checkout_FetchDigitalWalletPaymentCheckout($id: String, $reverbApp: String){
    checkout(input: { id: $id }) {
      _id
      action(input: { reverbApp: $reverbApp}) {
        _id
        type
        redirectUrl
      }
      paymentErrorMessage
    }
  }
`);
